import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Project } from '../state/project.model';
import { ProjectQuery } from '../state/project.query';
import { ProjectService } from '../state/project.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss']
})
export class ProjectListComponent implements OnInit {

  projects$: Observable<Project[]>;
  isLoading$ = this.projectQuery.isLoading$;
  removeConfirmated: number;
  searchTerm: string;

  constructor(
    private projectQuery: ProjectQuery,
    private projectService: ProjectService,
    private snakBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.projects$ = this.projectQuery.selectAll().pipe(
      catchError(error => {
        this.snakBar.open(`Error on list projects`, 'CLOSE');
        return throwError(error);
      })
    );
  }

  select(project: Project) {
    this.projectService.getCompleted(project.id)
      .pipe(catchError(error => {
        this.snakBar.open(`Error to get project informations`, 'CLOSE');
        return throwError(error);
      }))
      .subscribe(() => this.projectService.setActive(project.id));
  }

}
